import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { getCurrentDialog, viewSlice } from './features/view/viewSlice';
import { Settings } from './features/settings/Settings';
import { Login } from './components/Login';
import { TwoButtonDialog } from './components/Dialog';
import { useTranslation } from 'react-i18next';

import './DialogHandler.css';

export const DialogType = {
  CREATE_GAME: 1,
  LOGIN: 2,
  CONFIRM_GIVE_UP: 3,
  PAUSE: 4,
}

export const DialogHandler = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const currentDialog = useSelector(getCurrentDialog);
  if (currentDialog === null) {
    return props.children;
  }

  const dialogContent = (() => {
    switch (currentDialog.type) {
      case DialogType.CREATE_GAME: {
        return <Settings />;
      }
      case DialogType.LOGIN: {
        return <Login roomID={currentDialog.args.roomID} />;
      }
      case DialogType.CONFIRM_GIVE_UP: {
        const onYes = (e) => {
          batch(() => {
            dispatch(viewSlice.actions.closeDialog(DialogType.CONFIRM_GIVE_UP));
            dispatch({ type: 'action/giveup' });
          });
        };

        const onNo = (e) => {
          dispatch(viewSlice.actions.closeDialog(DialogType.CONFIRM_GIVE_UP));
        }

        return (
          <TwoButtonDialog title={t('GIVE_UP')} onButton1={onYes} button1Label={t('YES')} onButton2={onNo} button2Label={t('NO')}>
            {t('GIVE_UP_MSG')}
          </TwoButtonDialog>
        );
      }
      case DialogType.PAUSE: {
        const onAccept = (e) => {
          batch(() => {
            dispatch(viewSlice.actions.closeDialog(DialogType.PAUSE));
            dispatch({ type: 'action/acceptpause' });
          });
        };

        const onReject = (e) => {
          dispatch(viewSlice.actions.closeDialog(DialogType.PAUSE));
        }

        return (
          <TwoButtonDialog title={t('PAUSE')} onButton1={onAccept} button1Label={t('YES')} onButton2={onReject} button2Label={t('NO')}>
            {currentDialog.args.choice ? t('ACCEPT_PAUSE') : t('ACCEPT_UNPAUSE')}
          </TwoButtonDialog>
        );
      }
      default:
        throw Error('Unknown Dialog Type '+currentDialog.type);
    }
  })();

  return (
    <>
      <div className="backgroundWrapper">
        {props.children}
        <div className="dialogBackground"></div>
      </div>
      <div className="dialogWrapper">
        <div style={{flex: 1}}></div>
        <div className="dialog">
          {dialogContent}
        </div>
        <div style={{flex: 1}}></div>
      </div>
    </>
  );
};